import "./Shop.scss";
import React, { Component, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import images from "../../../ressources/images";
import ShopHeader from "../../../components/Shop/List/ShopHeader";
import ShopListItem from "../../../components/Shop/List/ShopListItem";
import InsLoader from "../../../components/InsLoader/InsLoader";
import ShopFilter from "../../../components/Shop/List/ShopFilter";
import * as actions from "../../../store/actions/storeActions";
import {
  getProducts,
  getCart,
  getCategories,
  setFilter,
  // clearCart,
} from "../../../api/shop";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";

export class Shop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cart: {},
      open: this.props.store.open,
      products: this.props.store.products,
      openFilter: false,
      loader: false,
      categories: this.props.store.categories,
      categoryImg: "",
      loaderFilter: true,
      lng: this.props.i18n.language,
      loading: false,
      offset: 0,
      hasMore: true,
      isFiltered: false,
      filters: {},
    };
  }

  resetFilters = () => {
    this.setState({ filter: {}, offset: 0, hasMore: true, isFiltered: false });
  };

  componentDidMount() {
    this.setState({ offset: 0 });
    this.getAllProducts();
    this.getAllCategories();
    this.getUserCart();
    this.props.refreshCart();
  }

  componentDidUpdate(prevProps) {
    if (this.state.lng !== this.props.i18n.language) {
      this.setState({ lng: this.props.i18n.language, offset: 0 }, () => {
        this.setState({ loader: true, open: true });
        this.getAllProducts();
        this.getAllCategories();
        this.getUserCart();
        this.props.refreshCart();
      });
    }

    if (prevProps.store.open !== this.props.store.open) {
      this.setState({ open: this.props.store.open });
    }

    if (prevProps.store.products !== this.props.store.products) {
      this.setState({ products: this.props.store.products });
    }

    if (prevProps.store.categories !== this.props.store.categories) {
      this.setState({ categories: this.props.store.categories });
    }
  }

  fetchAllProduct = async () => {
    const data = await getProducts({ offset: this.state.offset });
    const mergedData = [...this.state.products, ...data];

    this.setState({
      products: mergedData,
      offset: this.state.offset + 1,
      // Products are fetched 12 by 12
      hasMore: data.length === 12 ? true : false,
    });
  };

  fetchAllFilteredProduct = async () => {
    const data = await setFilter({
      offset: this.state.offset,
      ...this.state.obj,
    });
    console.log(data);
    const mergedData = [...this.state.products, ...data.gifts];

    this.setState({
      products: mergedData,
      offset: this.state.offset + 1,
      hasMore: data.length ? true : false,
    });
  };

  fetchMoreProducts = async () => {
    this.setState({ loading: true });

    if (this.state.isFiltered) {
      await this.fetchAllFilteredProduct();
    } else {
      await this.fetchAllProduct();
    }

    this.setState({ loading: false });
  };

  getAllProducts = () => {
    getProducts({ offset: this.state.offset }).then(
      (data) => {
        if (data.length < 1) {
          this.props.setOpen(false);
          this.setState({ open: false });
          return;
        }
        this.setState({
          products: data,
          loader: false,
          offset: this.state.offset + 1,
        });
        this.props.setProducts(data);
        this.props.setOpen(true);
      },
      () => {
        this.props.setOpen(false);
        this.setState({ open: false });
      }
    );
  };

  getAllCategories = () => {
    getCategories().then((data) => {
      this.props.setCategories({
        categories: data,
        categoryImg: data.defaultBanner?.name?.name,
        loaderFilter: false,
      });

      this.setState({
        categories: data,
        categoryImg: data.defaultBanner?.name?.name,
        loaderFilter: false,
      });
    });
  };

  updatedProducts = (data, obj) => {
    this.setState({
      products: data.gifts,
      categoryImg:
        data.category && data.category.picture
          ? data.category.picture.name.name
          : data.categories.defaultBanner
          ? data.categories.defaultBanner.name.name
          : this.state.categoryImg,
      openFilter: false,
      isFiltered: true,
      offset: 0,
      filters: obj,
    });
  };

  getUserCart = () => {
    getCart().then((data) => {
      this.setState({
        cart: data,
      });
    });
  };

  toggleFilter = () => {
    this.setState({ openFilter: !this.state.openFilter });
  };

  loadingSpinner = () => (
    <div
      style={{
        display: "flex",
        margin: "50px 0",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <LoadingSpinner loading={this.loading}></LoadingSpinner>
    </div>
  );

  generateOrderLimitMessage = () => {
    const { account: {
      openingSession: {
        max_order,
        order_placed,
      } = {}
    } } = this.props;
    
    if (!max_order) {
      return null;
    } else if (order_placed === 0) {
      return (
        <Trans
          i18nKey="limited_orders"
          defaults="<p><span className='black-bold'>⚠️INFO:</span> <span className='red-bold'>You are limited to {{limitation}} orders during the date of opening of the Shop.</span></p>"
          values={{ limitation: max_order }}
          components={{ span: <span /> }}
        />
      );
    } else if (order_placed < max_order) {
      return (
        <Trans
          i18nKey="orders_left"
          defaults="<p><span className='black-bold'>⚠️REMINDER:</span> <span className='red-bold'>You have {{limitation}} orders left during the entire time the gift shop is open.</span></p>"
          values={{ limitation: max_order - order_placed }}
          components={{ span: <span /> }}
        />
      );
    } else if (order_placed >= max_order){
      return (
        <Trans
          i18nKey="order_limit_reached"
          defaults="<p><span className='black-bold'>📦ORDER QUOTA REACHED:</span> <span className='red-bold'>you have already placed {{limitation}} orders</span></p>"
          values={{ limitation: order_placed }}
          components={{ span: <span /> }}
        />
      );
    }
  };

  render() {
    const {
      cart,
      categories,
      categoryImg,
      loader,
      loaderFilter,
      open,
      openFilter,
      products,
    } = this.state;
    const { account, t } = this.props;
    const { openingSession: { max_order, order_placed } = {}, ongoingSessions = false } = account;
    const isOrderLimitReached = max_order && (order_placed >= max_order);
    const ShopListItemElement = isOrderLimitReached ? 'div' : Link;

    return (
      <div className="default-layout--min-height flex flex-col">
        {open && ongoingSessions ? (
          <>
            <ShopHeader
              account={account}
              cart={cart}
              filter={this.toggleFilter}
              t={t}
            />
            <ShopFilter
              offset={this.state.offset}
              className={openFilter ? "shop_filter open" : "shop_filter"}
              filter={this.toggleFilter}
              updatedProducts={this.updatedProducts}
              categories={categories}
              loader={loaderFilter}
              resetFilters={this.resetFilters}
            />
            <div className="limited_order">
              {this.generateOrderLimitMessage()}
            </div>
            <div className="product_list flex-1">
              <div className="product_list-banner">
                <img src={categories.defaultBanner && categoryImg} alt="" />
              </div>
              <div className="items_container">
                  {loader ? (
                    <InsLoader />
                  ) : (
                    <InfiniteScroll
                      dataLength={products.length}
                      className="item_list"
                      hasMore={this.state.hasMore}
                      loader={
                        <div
                          style={{
                            display: "flex",
                            margin: "10px 0",
                            width: "100%",
                            justifyContent: "center",
                          }}
                        >
                          <LoadingSpinner
                            loading={this.state.loading}
                          ></LoadingSpinner>
                        </div>
                      }
                      next={this.fetchMoreProducts}
                    >
                      {products.map((product, index) => (
                        <ShopListItemElement
                          key={index}
                          className={
                            product.star
                              ? "product_wrapper big"
                              : "product_wrapper"
                          }
                          to={{
                            pathname: "/shop/product/" + product.id,
                            state: { transitionName: "slide_in" },
                          }}
                        >
                            <ShopListItem
                              variations={product.variations}
                              name={product.name}
                              brand={product.brand.name}
                              image={
                                product.pictures.length
                                  ? product.pictures[0].name.name_333
                                  : images.we_are_lol_black
                              }
                              points={product.points}
                              stock={product.stock}
                              star={product.star}
                              limited={product.limited}
                              userPoints={account.points}
                              cart={cart}
                              isOrderLimitReached={isOrderLimitReached}
                            />
                        </ShopListItemElement>
                      ))}
                    </InfiniteScroll>
                  )}
                </div>
            </div>
          </>
        ) : (
          <div>
            {this.props.i18n.language === "es-ES" ? (
              <img
                src={images.shop_waiting_es}
                className="shop_waiting"
                alt={t("waiting_shop")}
              />
            ) : (
              <img
                src={images.shop_waiting_default}
                className="shop_waiting"
                alt={t("waiting_shop")}
              />
            )}
            <div className="shop_text">
              <h2>{t("shop_patience")}</h2>
              <p>{t("shop_close")}</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setProducts: (products) => {
      dispatch(actions.setProducts(products));
    },
    setCategories: (categories) => {
      dispatch(actions.setCategories(categories));
    },
    setOpen: (bool) => {
      dispatch(actions.setOpen(bool));
    },
    refreshCart: () => {
      dispatch(actions.refreshCart());
    },
    resetStore: () => {
      dispatch(actions.resetStore());
    },
  };
};

//extract data from the redux store
const mapStateToProps = (state) => ({
  account: state.account,
  store: state.store,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Shop));
